import { config } from './config';

// AWS Amplify Configuration for Admin Portal
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.COGNITO_USER_POOL_ID,
      userPoolClientId: config.COGNITO_CLIENT_ID,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 12,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
  API: {
    REST: {
      ChulasAdminAPI: {
        endpoint: config.API_ENDPOINT.replace(/\/$/, ''),
        region: config.REGION,
      },
      ChulasJobsAPI: {
        endpoint: config.JOBS_API_ENDPOINT.replace(/\/$/, ''),
        region: config.REGION,
      },
      ChulasEmployeeAPI: {
        endpoint: config.EMPLOYEE_API_ENDPOINT.replace(/\/$/, ''),
        region: config.REGION,
      },
    },
  },
  Agent: {
    gatewayUrl: config.AGENT_GATEWAY_URL,
    region: config.REGION,
    identityPoolId: config.IDENTITY_POOL_ID,
  },
};
